module.exports = __webpack_public_path__ + "img/expand.82aa3a1d.svg";